import { render, staticRenderFns } from "./major.vue?vue&type=template&id=2655df12&"
import script from "./major.vue?vue&type=script&lang=js&"
export * from "./major.vue?vue&type=script&lang=js&"
import style0 from "./major.vue?vue&type=style&index=0&id=2655df12&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports